import { render } from "./ButtonGroupComponent.vue?vue&type=template&id=02deccda"
import script from "./ButtonGroupComponent.vue?vue&type=script&lang=js"
export * from "./ButtonGroupComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__